import React from 'react'

export const SubImportContext = React.createContext()

import { sendToAnalytics } from '../../Analytics'

import { UserContext } from '../../UserContext'

export const SubImportProvider = ({ children }) => {
    const { username } = React.useContext(UserContext)

    // State for tracking which import dialog is open
    const [activeSubImportDialog, setActiveSubImportDialog] = React.useState({})

    // Common methods to open/close dialogs
    const closeSubImportDialog = () => setActiveSubImportDialog({})

    React.useEffect(() => {
        if (
            Object.keys(activeSubImportDialog) &&
            Object.keys(activeSubImportDialog).length
        )
            sendToAnalytics({
                userId: username,
                event: 'choose_subimport_app',
                data: { app: activeSubImportDialog },
            })
    }, [activeSubImportDialog])

    return (
        <SubImportContext.Provider
            value={{
                activeSubImportDialog,
                setActiveSubImportDialog,
                closeSubImportDialog,
            }}
        >
            {children}
        </SubImportContext.Provider>
    )
}
